import { render, staticRenderFns } from "./HomeTab.vue?vue&type=template&id=04789368&scoped=true"
import script from "./HomeTab.vue?vue&type=script&lang=js"
export * from "./HomeTab.vue?vue&type=script&lang=js"
import style0 from "./HomeTab.vue?vue&type=style&index=0&id=04789368&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04789368",
  null
  
)

export default component.exports